import { Form, FormField, PrimaryButton, SecondaryButton } from "common/Forms";
import { InRow } from "common/Grid";
import { TableRenderer } from "common/Table";
import { useState } from "react";
import { BiEnvelope } from "react-icons/bi";
import { TbDownload } from "react-icons/tb";
import { ModalDialog } from "common/Dialog";
import { TextInput } from "common/Forms/inputs";
import { useInvoiceSendMutation } from "store/action/invoiceApi";
import { toast } from "react-toastify";

export const TableView = ({ invoiceList }) => {
  const [emailModalOpen, setEmailModalOpen] = useState(false);
  const textInputBoxClass = ["text_input_box"];

  const [email, setEmail] = useState("");
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [isSending, setIsSending] = useState(false);

  const [invoiceSend] = useInvoiceSendMutation();

  const openEmailModal = (invoice) => {
    setSelectedInvoice(invoice);
    setEmail("");
    setEmailModalOpen(true);
  };

  const closeEmailModal = () => {
    setEmailModalOpen(false);
    setSelectedInvoice(null);
  };

  const isValidEmail = (val) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
  };

  const handleSendInvoice = async () => {
    setIsSending(true);

    const trimmedEmail = email.trim();

    const payload = {
      siteId: selectedInvoice?.siteId,
      invoiceId: selectedInvoice?.invoiceId,
      isDownload: false,
      email: trimmedEmail
    };

    await invoiceSend({ body: payload }).then((res) => {
      if (res?.data?.status === "SUCCESS") {
        toast.success(res?.data?.message || "Invoice sent successfully");
        closeEmailModal();
      } else {
        toast.error("Something went wrong");
      }
    }).finally(() => {
      setIsSending(false);
    });
  };


  return (
    <Form>
      <TableRenderer
        data={invoiceList ?? []}
        columns={[
          {
            name: 'Actions',
            widthRequest: { min: 150 },
            classNames: ['!text-center'],
            headerRenderer: (col) => (
              <div className="w-full text-center">{col.name}</div>
            ),
            bodyRenderer: (x) =>
              <InRow gap={1} classNames={['justify-center']}>
                <SecondaryButton action={() => openEmailModal(x)} title="Send Invoice">
                  <BiEnvelope size={20} />
                </SecondaryButton>
                <SecondaryButton action={() => window.open(x?.pdfUrl, '_blank')} title="Download Invoice">
                  <TbDownload size={20} />
                </SecondaryButton>
              </InRow>
          },
          {
            name: 'Site ID',
            widthRequest: { min: 100 },
            bodyRenderer: (x) => x?.siteId || <div>-</div>
          },
          {
            name: 'Site Name',
            widthRequest: { min: 220 },
            bodyRenderer: (x) => x?.siteName || <div>-</div>
          },
          {
            name: 'Include Fee',
            widthRequest: { min: 150 },
            bodyRenderer: (x) => {
              const fees = x?.fees;
              if (!fees || fees.length === 0) return <div>-</div>;
              return <div>{Array.isArray(fees) ? fees.join(', ') : fees}</div>;
            }
          },
          {
            name: 'Order type',
            widthRequest: { min: 120 },
            bodyRenderer: (x) => x?.orderType ? x.orderType.charAt(0).toUpperCase() + x.orderType.slice(1) : <div>-</div>
          },
          {
            name: 'Start Date',
            widthRequest: { min: 150 },
            bodyRenderer: (x) => x?.startDate || <div>-</div>
          },
          {
            name: 'End Date',
            widthRequest: { min: 150 },
            bodyRenderer: (x) => x?.endDate || <div>-</div>
          },
          {
            name: 'Total Admin Fee',
            widthRequest: { min: 150 },
            bodyRenderer: (x) => `${x?.totalAdminFee || '-'} ${x?.currency ? `(${x?.currency?.toUpperCase()})` : ''}`
          },
          {
            name: 'Total Sales Fee',
            widthRequest: { min: 150 },
            bodyRenderer: (x) => `${x?.totalSalesFee || '-'} ${x?.currency ? `(${x?.currency?.toUpperCase()})` : ''}`
          },
          {
            name: 'Gross Amount',
            widthRequest: { min: 150 },
            bodyRenderer: (x) => `${x?.grossAmount || '-'} ${x?.currency ? `(${x?.currency?.toUpperCase()})` : ''}`
          },
          {
            name: 'Invoice Amount',
            widthRequest: { min: 150 },
            bodyRenderer: (x) => `${x?.invoiceAmount || '-'} ${x?.currency ? `(${x?.currency?.toUpperCase()})` : ''}`
          },
          {
            name: 'Order Count',
            widthRequest: { min: 150 },
            bodyRenderer: (x) => x?.orderCount || <div>-</div>
          }
        ]}
      />

      <ModalDialog
        isOpened={emailModalOpen}
        classNames={["w-[35%]"]}
        title="Send Invoice Email">
        <FormField
          id="email"
          type="email"
          classNames={textInputBoxClass}
          label="Email"
          inputFactory={(id, name, onValidation) => (
            <TextInput
              type="email"
              placeholder="Enter email address"
              value={email}
              onChange={(_, val) => setEmail(val)}
            />
          )}
        />

        <InRow gap={1} classNames={['justify-end', 'p-3']}>
          <PrimaryButton
            action={handleSendInvoice}
            disabled={!isValidEmail(email.trim()) || isSending}>
            Send
          </PrimaryButton>
          <SecondaryButton action={closeEmailModal}>
            Close
          </SecondaryButton>
        </InRow>
      </ModalDialog>

    </Form>
  );
};
